import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/home/Home.jsx";

const Contact = lazy(() => import("./components/contact/Contact.jsx"));
const About = lazy(() => import("./components/about/About.jsx"));
const Gowns = lazy(() => import("./components/pages/Gowns.jsx"));
const ViewProduct = lazy(() => import("./components/pages/ViewProduct.jsx"));
const SizeChart = lazy(() => import("./components/SizeChart/SizeChart.jsx"));

function RouteFallback() {
	return (
		<div className="min-h-[40vh] flex items-center justify-center" role="status" aria-live="polite">
			<span className="text-gray-600 font-medium">Loading page…</span>
		</div>
	);
}

function App() {
	return (
		<Router>
			<Suspense fallback={<RouteFallback />}>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/about" element={<About />} />
					<Route path="/gowns/:year" element={<Gowns />} />
					<Route path="/Gowns/id/:style" element={<ViewProduct />} />
					<Route path="/size-chart/:category" element={<SizeChart />} />
				</Routes>
			</Suspense>
		</Router>
	);
}

export default App;
